<template>
    <div class="container pt-2">
        <h3>Geral</h3>
        <div class="row justify-content-md-center pt-3">
            <!-- CARD RESUMO -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setResumo">
                    <div class="card-header bg-info-title-light cardCustom">
                        <h5 class="text-info-title-light">Transportes Ativos</h5>
                    </div>
                    <div class="card-body bg-info-body-light">
                        <p class="card-title text-secondary"><strong>Transportes: </strong>{{ cardTransportesMax }}</p>
                        <hr>
                        <p class="card-title text-secondary"><strong>Ativos: </strong>{{ cardTransportesAtivos }}</p>
                    </div>
                </div>
            </div>
            <!-- CARD TRANSPORTES ATRASADOS -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setAtrasados">
                    <div class="card-header bg-danger-title-light cardCustom">
                        <h5 class="text-danger-title-light">Transportes Atrasados</h5>
                    </div>
                    <div class="card-body bg-danger-body-light">
                        <p class="card-title text-secondary"><strong>Transportes: </strong>{{ cardTransportesMax }}</p>
                        <hr>
                        <p class="card-title text-secondary"><strong>Atrasados: </strong>{{ cardTransportesAtrasados }}</p>
                    </div>
                </div>
            </div>
            <!-- CARD MOTORISTAS OCIOSOS -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setOciosos">
                    <div class="card-header bg-warning-title-light cardCustom">
                        <h5 class="text-warning-title-light">Motoristas Ociosos</h5>
                    </div>
                    <div class="card-body bg-warning-body-light">
                        <p class="card-title text-secondary"><strong>Total de Motoristas: </strong>{{ cardMotoristasMax }}</p>
                        <hr>
                        <p class="card-title text-secondary"><strong>Motoristas Ociosos: </strong>{{ cardMotoristasOciosos }}</p>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <h3>Resumo da Semana</h3>
        <div class="row justify-content-md-center pt-3">
            <!-- CARD NOVOS TRANSPORTES -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setNovos">
                    <div class="card-header bg-success-title-light cardCustom">
                        <h5 class="text-success-title-light">Novos Transportes</h5>
                    </div>
                    <div class="card-body bg-success-body-light">
                        <p class="card-title text-secondary">{{ cardNovosSemanaMax }} Transportes Novos</p>
                    </div>
                </div>
            </div>
            <!-- CARD TRANSPORTES FINALIZADOS -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setFinalizados">
                    <div class="card-header bg-secondary-title-light cardCustom">
                        <h5 class="text-secondary-title-light">Transportes Finalizados</h5>
                    </div>
                    <div class="card-body bg-secondary-body-light">
                        <p class="card-title text-secondary">{{ cardFinalizadosSemanaMax }} Transportes Finalizados</p>
                    </div>
                </div>
            </div>
            <!-- CARD MOTORISTAS OCIOSOS @change="loadStatus()" -->
            <div class="col-md-4 pb-2">
                <div class="card text-center cardCustom" @click="setStatus">
                    <div class="card-header bg-purple-title-light headerCustom">
                        <div class="text-purple-title-light">
                            <div class="col-md-12">
                                <b-form-group>
                                    <b-form-select id="status" :options="statuses"
                                        v-model="temp.id"
                                        @change="getCardStatusSemana"
                                        placeholder="Informe o nome do status."
                                        class="textInputCmb"/>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <div class="card-body bg-purple-body-light">
                        <p class="card-title text-secondary" v-if="cardStatusSemanaMax">{{ cardStatusSemanaMax }} Transportes neste Status</p>
                        <p class="card-title text-secondary" v-else>Selecione o Status</p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <p class="text-right pt-2 text-sm pb-3"><i>Informações da semana de {{ firstDay }} à {{ lastDay }}</i></p>
        </div>
        <h3 class="pt-3">Dados:</h3>
        <div class="row justify-content-md-center">
            <div class="col-md-12">
                <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
                    <b-table v-if="modo==='resumo'" hover striped class="text-center align-middle table" :items="cardTransportes" :fields="fieldsResumo">
                    </b-table>
                    <div class="row" v-if="exibeRodapeT && modo==='resumo'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='atrasados'" hover striped class="text-center align-middle table" :items="cardAtrasados" :fields="fieldsAtrasados">
                    </b-table>
                    <div class="row" v-if="exibeRodapeA && modo==='atrasados'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='ociosos'" hover striped class="text-center align-middle table" :items="cardOciosos" :fields="fieldsOciosos">
                    </b-table>
                    <div class="row" v-if="exibeRodapeCO && modo==='ociosos'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='novos'" hover striped class="text-center align-middle table" :items="cardNovosSemana" :fields="fieldsNovos">
                    </b-table>
                    <div class="row" v-if="exibeRodapeNS && modo==='novos'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='finalizados'" hover striped class="text-center align-middle table" :items="cardFinalizadosSemana" :fields="fieldsFinalizados">
                    </b-table>
                    <div class="row" v-if="exibeRodapeFS && modo==='finalizados'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='status'" hover striped class="text-center align-middle table" :items="cardStatusSemana" :fields="fieldsStatus">
                    </b-table>
                    <div class="row" v-if="exibeRodapeSS && modo==='status'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <b-table v-if="modo==='resumo'" hover striped class="text-center align-middle table" :items="cardTransportes" :fields="fieldsResumo">
                    </b-table>
                    <div class="row" v-if="exibeRodapeT && modo==='resumo'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='atrasados'" hover striped class="text-center align-middle table" :items="cardAtrasados" :fields="fieldsAtrasados">
                    </b-table>
                    <div class="row" v-if="exibeRodapeA && modo==='atrasados'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='ociosos'" hover striped class="text-center align-middle table" :items="cardOciosos" :fields="fieldsOciosos">
                    </b-table>
                    <div class="row" v-if="exibeRodapeCO && modo==='ociosos'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='novos'" hover striped class="text-center align-middle table" :items="cardNovosSemana" :fields="fieldsNovos">
                    </b-table>
                    <div class="row" v-if="exibeRodapeNS && modo==='novos'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='finalizados'" hover striped class="text-center align-middle table" :items="cardFinalizadosSemana" :fields="fieldsFinalizados">
                    </b-table>
                    <div class="row" v-if="exibeRodapeFS && modo==='finalizados'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                    <b-table v-if="modo==='status'" hover striped class="text-center align-middle table" :items="cardStatusSemana" :fields="fieldsStatus">
                    </b-table>
                    <div class="row" v-if="exibeRodapeSS && modo==='status'">
                        <div class="col-md-12 text-center mb-3">
                            <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: "Home",
    data: function() {
        return {
            modo: 'resumo',
            cardTransportesMax: 0,
            cardTransportesAtivos: 0,
            cardTransportesAtrasados: 0,
            cardMotoristasMax: 0,
            cardMotoristasAtivos: 0,
            cardMotoristasOciosos: 0,
            cardTransportes: [],
            cardAtrasados: [],
            cardOciosos: [],
            cardStatusSemana: [],
            cardStatusSemanaMax: '',
            cardNovosSemana: [],
            cardNovosSemanaMax: '',
            cardFinalizadosSemana: [],
            cardFinalizadosSemanaMax: '',
            temp: {},
            statuses: [],
            fieldsResumo: [
                { key: 'rastreio', label: 'Status', sortable: true },
                { key: 'origem', label: 'Origem', sortable: true },
                { key: 'destino', label: 'Destino', sortable: true },
                { key: 'motorista', label: 'Motorista', sortable: true },
                { key: 'data_inicio', label: 'Início', sortable: true, formatter: 'formatData' },
                { key: 'data_final', label: 'Previsão', sortable: true, formatter: 'formatData' },
                { key: 'status', label: 'Status Atual', sortable: true }
            ],
            fieldsAtrasados: [
                { key: 'origem', label: 'Origem', sortable: true },
                { key: 'destino', label: 'Destino', sortable: true },
                { key: 'motorista', label: 'Motorista', sortable: true },
                { key: 'rastreio', label: 'Rastreio', sortable: true },
                { key: 'data_final', label: 'Previsão', sortable: true, formatter: 'formatData' },
                { key: 'dias_atrasados', label: 'Atrasados', sortable: true }
            ],
            fieldsOciosos: [
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'rastreio', label: 'Último Transporte', sortable: true },
                { key: 'dias_livres', label: 'Dias Livres', sortable: true }
            ],
            fieldsNovos: [
                { key: 'rastreio', label: 'Rastreio', sortable: true },
                { key: 'data', label: 'Data de Atualização', sortable: true, formatter: 'formatData' }
            ],
            fieldsFinalizados: [
                { key: 'rastreio', label: 'Rastreio', sortable: true },
                { key: 'data', label: 'Data de Atualização', sortable: true, formatter: 'formatData' }
            ],
            fieldsStatus: [
                { key: 'rastreio', label: 'Rastreio', sortable: true },
                { key: 'data', label: 'Data de Atualização', sortable: true, formatter: 'formatData' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            firstDay: '',
            lastDay: '',
            exibeRodapeSS: true,
            exibeRodapeNS: true,
            exibeRodapeFS: true,
            exibeRodapeT: true,
            exibeRodapeA: true,
            exibeRodapeCO: true
        }
    },
    methods: {
        getWeek() {
            this.firstDay = new Date()
            this.lastDay = new Date()
            const hoje = new Date()
            const diaSemana = hoje.getDay()
            if(diaSemana===0) {
                this.lastDay.setDate(this.lastDay.getDate() + 6)
            }else if(diaSemana===1) {
                this.firstDay.setDate(this.firstDay.getDate() - 1)
                this.lastDay.setDate(this.lastDay.getDate() + 5)
            }else if(diaSemana===2) {
                this.firstDay.setDate(this.firstDay.getDate() - 2)
                this.lastDay.setDate(this.lastDay.getDate() + 4)
            }else if(diaSemana===3) {
                this.firstDay.setDate(this.firstDay.getDate() - 3)
                this.lastDay.setDate(this.lastDay.getDate() + 3)
            }else if(diaSemana===4) {
                this.firstDay.setDate(this.firstDay.getDate() - 4)
                this.lastDay.setDate(this.lastDay.getDate() + 2)
            }else if(diaSemana===5) {
                this.firstDay.setDate(this.firstDay.getDate() - 5)
                this.lastDay.setDate(this.lastDay.getDate() + 1)
            }else if(diaSemana===6) {
                this.firstDay.setDate(this.firstDay.getDate() - 6)
            }

            const tfDia = this.firstDay.getDate().toString()
            const tfDiaF = (tfDia.length == 1) ? '0'+tfDia : tfDia
            const tfMes  = (this.firstDay.getMonth()+1).toString()
            const tfMesF = (tfMes.length == 1) ? '0'+tfMes : tfMes
            const tfAnoF = this.firstDay.getFullYear()
            this.firstDay = tfDiaF + '/' + tfMesF + '/' + tfAnoF
            this.temp.inicio = tfAnoF + '-' + tfMesF + '-' + tfDiaF

            const tlDia = this.lastDay.getDate().toString()
            const tlDiaF = (tlDia.length == 1) ? '0'+tlDia : tlDia
            const tlMes  = (this.lastDay.getMonth()+1).toString()
            const tlMesF = (tlMes.length == 1) ? '0'+tlMes : tlMes
            const tlAnoF = this.lastDay.getFullYear()
            this.lastDay = tlDiaF + '/' + tlMesF + '/' + tlAnoF
            this.temp.final = tlAnoF + '-' + tlMesF + '-' + tlDiaF
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        setResumo() {
            this.modo = 'resumo'
        },
        setAtrasados() {
            this.modo = 'atrasados'
        },
        setOciosos() {
            this.modo = 'ociosos'
        },
        setNovos() {
            this.modo = 'novos'
            this.loadCardNovosSemana()
        },
        setFinalizados() {
            this.modo = 'finalizados'
            this.loadCardFinalizadosSemana()
        },
        setStatus() {
            this.modo = 'status'
            this.getCardStatusSemana()
        },
        getCardStatusSemana() {
            this.loadCardStatusSemanaMax()
            this.loadCardStatusSemana()
        },
        loadCardStatusSemanaMax() {
            const url = `${baseApiUrl}/backend/cardStatusSemanaMax.php?status=${this.temp.id}&inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardStatusSemanaMax = res.data[0].max
            })
        },
        loadCardStatusSemana() {
            const url = `${baseApiUrl}/backend/cardStatusSemana.php?status=${this.temp.id}&inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardStatusSemana = res.data
                    this.exibeRodapeSS = false
                }else{
                    this.cardStatusSemana = []
                    this.exibeRodapeSS = true
                }
            })
        },
        loadCardNovosSemanaMax() {
            const url = `${baseApiUrl}/backend/cardNovosSemanaMax.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardNovosSemanaMax = res.data[0].max
            })
        },
        loadCardNovosSemana() {
            const url = `${baseApiUrl}/backend/cardNovosSemana.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardNovosSemana = res.data
                    this.exibeRodapeNS = false
                }else{
                    this.loadCardNovosSemana = []
                    this.exibeRodapeNS = true
                }
            })
        },
        loadCardFinalizadosSemanaMax() {
            const url = `${baseApiUrl}/backend/cardFinalizadosSemanaMax.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                this.cardFinalizadosSemanaMax = res.data[0].max
            })
        },
        loadCardFinalizadosSemana() {
            const url = `${baseApiUrl}/backend/cardFinalizadosSemana.php?inicio=${this.temp.inicio}&final=${this.temp.final}`
            axios.get(url).then(res => {
                if(res.data.length > 0){
                    this.cardFinalizadosSemana = res.data
                    this.exibeRodapeFS = false
                }else{
                    this.cardFinalizadosSemana = []
                    this.exibeRodapeFS = true
                }
            })
        },
        loadCardTransportes() {
            const url = `${baseApiUrl}/backend/cardTransportes.php`
            axios.get(url).then(res => {
                this.cardTransportes = res.data
                if(this.cardTransportes.length > 0){
                    this.exibeRodapeT = false
                }else{
                    this.exibeRodapeT = true
                }
            })
        },
        loadCardAtrasados() {
            const url = `${baseApiUrl}/backend/cardAtrasados.php`
            axios.get(url).then(res => {
                this.cardAtrasados = res.data
                if(this.cardAtrasados.length > 0){
                    this.exibeRodapeA = false
                }else{
                    this.exibeRodapeA = true
                }
            })
        },
        loadCardOciosos() {
            const url = `${baseApiUrl}/backend/cardMotoristas.php`
            axios.get(url).then(res => {
                this.cardOciosos = res.data
                if(this.cardOciosos.length > 0){
                    this.exibeRodapeCO = false
                }else{
                    this.exibeRodapeCO = true
                }
            })
        },
        loadItensCardTransportes() {
            const url = `${baseApiUrl}/backend/itensCardTransportes.php`
            axios.get(url).then(res => {
                const i = res.data.length - 1
                this.cardTransportesMax = res.data[i].transporte_total
                this.cardTransportesAtivos = res.data[i].transporte_ativo
                this.cardTransportesAtrasados = res.data[i].transporte_atrasado
                this.cardMotoristasMax = res.data[i].motorista_total
                this.cardMotoristasAtivos = res.data[i].motorista_ativo
                this.cardMotoristasOciosos = res.data[i].motorista_ocioso
            })
        },
        loadStatuses() {
            const url = `${baseApiUrl}/backend/status.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.statuses = res.data.map(status => {
                        return { ...status, value: status.id, text: status.titulo }
                    })
                }else{
                    this.statuses.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        }
    },
    mounted() {
        this.getWeek()
        this.loadCardTransportes()
        this.loadCardAtrasados()
        this.loadCardOciosos()
        this.loadItensCardTransportes()
        this.loadStatuses()
        this.loadCardNovosSemanaMax()
        this.loadCardFinalizadosSemanaMax()
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
    .bg-success-title-light {
        background-color: rgba(40,167,69,0.75);
    }

    .text-success-title-light {
        color: #d3fddd !important;
    }

    .bg-success-body-light {
        background-color: rgba(40,167,69,0.15);
    }

    .bg-info-title-light {
        background-color: rgba(23, 162, 184, 0.75);
    }

    .text-info-title-light {
        color: #bcebf3 !important;
    }

    .bg-info-body-light {
        background-color: rgba(23,162,184,0.15);
    }

    .bg-danger-title-light {
        background-color: rgba(220,53,69,0.75);
    }

    .text-danger-title-light {
        color: #fce6e8 !important;
    }

    .bg-danger-body-light {
        background-color: rgba(220,53,69,0.15);
    }

    .bg-warning-title-light {
        background-color: rgba(255,193,7,0.75);
    }

    .text-warning-title-light {
        color: #fff9e7 !important;
    }

    .bg-warning-body-light {
        background-color: rgba(255,193,7,0.15);
    }

    .bg-secondary-title-light {
        background-color: rgba(108,117,125,0.75);
    }

    .text-secondary-title-light {
        color: #eaeaea !important;
    }

    .bg-secondary-body-light {
        background-color: rgba(108,117,125,0.15);
    }

    .bg-purple-title-light {
        background-color: rgba(111,66,193,0.75);
    }

    .text-purple-title-light {
        color: #dbd3e8 !important;
    }

    .bg-purple-body-light {
        background-color: rgba(111,66,193,0.15);
    }

    .text-sm {
        font-size: 0.8rem;
        color: #6C757D;
    }

    .cardCustom {
        border-radius: 0 !important;
    }

    .headerCustom {
        height: 57px !important;
        padding-top: 3px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
    }

    .textInputCmb {
    /* border: 1px solid rgb(220, 220, 220); */
    border: 0;
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 1.25rem !important;
    color: #dbd3e8 !important;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>